<template>
  <div>
    <!-- 物流信息查询 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="780px" center>
      <div class="content">
        <!-- 物流信息查询 -->
        <div class="row">
          <div class="label">
            {{ $t('message.logisticsInformationInquiry') }}
          </div>
          <!-- 物流状态 -->
          <div class="status">
            {{ $t('message.logisticsStatus') }}
          </div>
        </div>
        <!-- 物流信息查询 -->
        <div class="row">
          <div class="label">
            <input type="text" v-model="express_no" @keyup.enter="receiveList" @blur="receiveList"
              :placeholder="$t('message.pleaseEnterTheLogisticsTrackingNumber')">
          </div>
          <!-- 物流状态 -->
          <div class="status ">
            <span v-if="detail.created_by_name">
              <span v-if="detail.created_at" style="color: #67C23A;">
                已签收
              </span>
              <span v-else style="color: red;">
                未签收
              </span>
            </span>
            <span v-if="isStatus" style="color: red;">
              未查询到该物流单号
            </span>
          </div>
        </div>
        <!-- 收件人 -->
        <div class="row" v-if="detail.created_by_name">
          <!-- 收件人 ：  -->
          <div class="label">
            {{ $t('message.recipients') }}: {{ detail.created_by_name }}
          </div>
          <!-- 类别 ： -->
          <div class="status">
            {{ $t('message.category') }}: {{ detail.type_name }}
          </div>
        </div>
        <!-- 签收时间 ：  -->
        <div class="row" v-if="detail.created_at">
          <!-- 签收时间 ：  ：  -->
          <div class="label">
            {{ $t('message.signForTime') }}:{{ detail.created_at }}
          </div>

        </div>
        <!-- 订单号  -->
        <div class="row" v-for="(item, index) in detail.order_purchase_express" :key="index">
          <!-- 订单号  ：订单号 ：    客户名  -->
          <div class="label">
            {{ $t('message.orderNumber') }}: <router-link
              :to="'/orderPaymentDetail?order_sn=' + item.order_purchase.order_sn" target="_blank" class="a-link">
              {{ item.order_purchase.order_sn }}
            </router-link>
            {{ $t('message.userName') }}: {{ item.order_purchase.user.realname }}
          </div>
        </div>
        <!-- 交易号 ：  -->
        <div class="row" v-for="(item, index) in detail.order_purchase_express" :key="item.order_purchase_id">
          <!-- 交易号 ：  ：  -->
          <div class="label">
            {{ $t('message.transactionNumber') }}: {{ item.order_purchase.purchase_no }}
          </div>
        </div>
        <!-- 收件员备注 ：  -->
        <div class="row" v-if="detail.remark">
          <!-- 收件员备注 ：  ：  -->
          <div class="label">
            {{ $t('message.receiversNote') }}: {{ detail.remark }}
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false" type="primary">
          {{ $t("message.closure") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      express_no: '',
      detail: {},
      dialogVisible: false,
      isStatus: '',
    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.express_no = ''
        this.detail = {}
        this.isStatus = ''
      }
    }
  },
  methods: {
    receiveList() {
      if (!this.express_no) return false
      this.isStatus = ''
      this.$api.signInApi.receiveList({ express_no: this.express_no }).then((res) => {
        if (res.data.total) {
          res.data.data.forEach((list) => {
            // 数组去重
            var hash = {};
            list.order_purchase_express = list.order_purchase_express.reduce(function (item, next) {
              hash[next.express_no]
                ? ""
                : (hash[next.express_no] = true && item.push(next));
              return item;
            }, []);
          });
          this.detail = res.data.data[0];
        } else {
          this.detail = {}
          this.isStatus = '未查询到该物流单号'
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;
    font-size: 16px;

    .a-link {
      margin-right: 20px;
    }

    .label {
      flex: 2;
      margin-right: 20px;

      input {
        padding: 0 15px;
        height: 38px;
        border: 1px solid #DCDFE6;
        border-radius: 6px;
        width: 90%;

      }
    }

    .status {
      flex: 1;
    }
  }
}
</style>